import React from 'react';
import { Wrapper, Shape } from '.';
import './SimpleHero.scss';

const SimpleHero = (props) => {
  const {
    title,
  } = props;
  return (
    <section className="simple-hero">
      <div className="framing-shapes">
        <Shape
          shapeName="petal"
          shapeColour="#EEEA00"
        />
        <Shape
          shapeName="flower"
          shapeColour="#007307"
        />
        <Shape
          shapeName="circle"
          shapeColour="#FF5ABB"
        />
        <Shape
          shapeName="leaf"
          shapeColour="#F68E00"
        />
      </div>
      <Wrapper isBound>
        <h1 className="title">{title}</h1>
      </Wrapper>
    </section>
  );
};

export default SimpleHero;
